import deleteEstimateFile from '../../../Services/deleteEstimateFile';

export default (media) => async (dispatch) => {

  dispatch(deleteEstimateFile(media))
  
}